export const SCHOOL_IS_NOT_LISTED_WARNING = "Your school may be listed under a different city name than the one you have selected. Verify the school's address and search again."


// WEBPACK FOOTER //
// ./src/components/SchoolLookUp/constants.js